<template>
  <v-app>
    <v-app-bar app color="#3a3a3a" dark>
      <v-toolbar-title>
        <router-link to="/" class="toolbar-title white--text navbar-link">Performance</router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn color="#c0c700" text to="/">Assessment</v-btn>
        <v-btn color="#c0c700" text to="/company">Company</v-btn>
        <v-btn color="#c0c700" text to="/workshop">Workshop</v-btn>
        <v-btn color="#c0c700" text to="/coaching">Coaching</v-btn>
        <!-- <v-btn color="#c0c700" text to="/voucher">Voucher</v-btn> -->
        <v-speed-dial
          v-model="fab"
          :direction="direction"
          :open-on-hover="hover"
          :transition="transition"
          class="mt-2"
        >
          <template v-slot:activator>
            <v-btn v-model="fab" color="blue darken-2" dark fab small>
              <v-icon v-if="fab">mdi-close</v-icon>
              <v-icon v-else>mdi-account-circle</v-icon>
            </v-btn>
          </template>
          <v-btn fab dark small color="green" @click="onGoToProfile()">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn fab dark small color="red" @click="onSignOut()">
            <v-icon>exit_to_app</v-icon>
          </v-btn>
        </v-speed-dial>
      </v-toolbar-items>
    </v-app-bar>

    <v-content>
      <slot />
    </v-content>
  </v-app>
</template>

<script>
import { Auth } from "aws-amplify";
export default {
  methods: {
    async onSignOut() {
      await this.$store.dispatch("logout");
      this.$router.push("/login");
    }
  },
  data: () => ({
    direction: "bottom",
    fab: false,
    fling: false,
    hover: false,
    tabs: null,
    transition: "slide-y-reverse-transition"
  }),
  computed: {
    activeFab() {
      switch (this.tabs) {
        case "one":
          return { class: "purple", icon: "account_circle" };
        case "two":
          return { class: "red", icon: "edit" };
        case "three":
          return { class: "green", icon: "keyboard_arrow_up" };
        default:
          return {};
      }
    }
  }
};
</script>
